import React from 'react';
import PropTypes from 'prop-types';

import { WHITE } from '@constant/colors';

const DefaultError = ({ className, color }) => (
  <svg className={className} viewBox="20 19 12 13">
    <path
      d="M26,31 C29.3137085,31 32,28.3137085 32,25 C32,21.6862915 29.3137085,19 26,19 C22.6862915,19 20,21.6862915 20,25 C20,28.3137085 22.6862915,31 26,31 Z M26.0000489,29.1999879 C26.6627906,29.1999879 27.2000489,28.6627296 27.2000489,27.9999878 C27.2000489,27.3372461 26.6627906,26.7999878 26.0000489,26.7999878 C25.3373071,26.7999878 24.8000488,27.3372461 24.8000488,27.9999878 C24.8000488,28.6627296 25.3373071,29.1999879 26.0000489,29.1999879 Z M25.0124512,21.8014527 C25.0124512,21.6606168 25.0987942,20.9847745 25.9823553,20.9847745 C26.8659164,20.9847745 27.0124511,21.5784025 27.0124512,21.8014527 C27.0124512,22.0245029 26.8549194,24.9874878 26.8549194,24.9874878 C26.8549194,24.9874878 26.7236328,25.8585815 25.9823553,25.8585815 C25.2410778,25.8585815 25.113787,24.9874878 25.113787,24.9874878 C25.113787,24.9874878 25.0124512,21.9422885 25.0124512,21.8014527 Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

DefaultError.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

DefaultError.defaultProps = {
  color: WHITE,
};

export default DefaultError;
